// Scheduled Jobs API client (admin). Persisted cron-like jobs (backup /
// sql-script / webhook) run by the in-process scheduler, with run history.
import { api } from './api.js';

export const listJobs    = () => api.get('/api/tools/jobs').then((r) => r.jobs || []);
export const getJob      = (id) => api.get(`/api/tools/jobs/${id}`);
export const createJob   = (j) => api.post('/api/tools/jobs', j);
export const updateJob   = (id, j) => api.put(`/api/tools/jobs/${id}`, j);
export const deleteJob   = (id) => api.delete(`/api/tools/jobs/${id}`);
export const runJobNow   = (id) => api.post(`/api/tools/jobs/${id}/run`);
export const listJobRuns = (id) => api.get(`/api/tools/jobs/${id}/runs`).then((r) => r.runs || []);
export const listRecentRuns = (limit = 100) => api.get(`/api/tools/jobs/runs?limit=${limit}`).then((r) => r.runs || []);
export const artifactUrl = (runId) => `/api/tools/jobs/runs/${runId}/download`;
